import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { to: '/category/mingxing-heiliao', label: '明星黑料' },
      { to: '/category/wanghong-bagua', label: '网红爆料' },
      { to: '/category/yulequan-neimu', label: '娱乐圈内幕' },
      { to: '/category/zongyi-jiemu', label: '综艺节目' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about', label: '联系我们' },
      { to: '/about', label: '用户口碑' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { to: '#', label: '娱乐头条' },
      { to: '#', label: '星闻速递' },
      { to: '#', label: '八卦聚焦' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading text-primary-400">黑料社</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              最新独家黑料爆料聚合平台
              <br />
              第一时间掌握娱乐圈内幕资讯
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold text-background-200 mb-3">
                {group.title}
              </h3>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700/60 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 黑料社 HeiliaoShe.com - 版权所有。本站内容仅供娱乐参考，不代表任何立场。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">免责声明</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}